import { Grid } from '@mui/material';
import { AssetTypes } from '@tassat/common-definitions';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getApiBalances } from 'Selectors/assetBalancesStats';

import { renderCurrencyStats, renderSecurityStats } from './StatisticsRendererHelper';
import muiStyles from './styles';

const ApiOpsTransactionStatistics: React.FC = () => {
    const apiBalanceStats = useAppSelector(getApiBalances);
    const classes = muiStyles();

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            spacing={0}
            wrap='wrap'
        >
            <Grid
                className={classes.details}
                container
                direction='row'
                item
                justifyContent='space-between'
                spacing={0}
                wrap='wrap'
            >
                {/* TODO: once ticket updated change this reverse to sort by ticker when USD is changed to USD */}
                {apiBalanceStats
                    .sort((a, b) => b.assetType.localeCompare(a.assetType))
                    .map((apiBalanceStat) => {
                        if (apiBalanceStat.assetType === AssetTypes.ASSET){
                            return renderSecurityStats(apiBalanceStat, classes);
                        }

                        if (apiBalanceStat.assetType === AssetTypes.CURRENCY){
                            return renderCurrencyStats(apiBalanceStat, classes);
                        }

                        return null;
                    })}
            </Grid>
        </Grid>
    );
};

export default ApiOpsTransactionStatistics;